"use strict";

// ----------------------
// コンテナクエリポリフィル
const supportsContainerQueries = "container" in document.documentElement.style;
if (!supportsContainerQueries) {
  import("container-query-polyfill");
}
if ("scrollRestoration" in history) {
  history.scrollRestoration = "manual";
}
// ===========================================
//  variable / 変数宣言
// ===========================================
// アクティブなクラス
const IS_ACTIVE = "is-active";
const scrollLock = new ScrollLock();

// ===========================================
//  library / ライブラリ
// ===========================================
import { CssCustomProperties } from "./utility/_cssCustomProperties";
import { SmoothScroll } from "./utility/_smoothScroll";
import { Drawer } from "./utility/_drawer";
import * as modGsap from "./utility/_gsap";
modGsap.init({ scrollTrigger: true });
import { ScrollLock } from "./utility/_scrollLock";

// ===========================================
//  setup /
// ===========================================

// ----------------------
//  Drawer
const setupDrawer = () => {
  const drawer = document.querySelector(".js-drawer");
  const button = document.querySelector(".js-drawer-button");
  const header = document.querySelector(".header");
  const anchorLinks = header.querySelectorAll(".js-anchor");
  const backdrop = document.querySelector(".js-backdrop");
  const elements = {
    button,
    drawer,
    header,
    anchorLinks,
    backdrop,
  };
  new Drawer(elements);
};
// ===========================================
//  function / 処理
// ===========================================
const openingTl = modGsap.gsap.timeline();
// カバー
const coverLogo = document.querySelector(".cover-logo");
const coverWrap = document.querySelector(".cover-wrap");

const kv = document.querySelector(".kv");
const kvCircle = document.querySelector(".kv-circle");
const kvCircleWrap = document.querySelector(".kv-circle-wrap");
const CircleWrap1 = document.querySelector(".circle-wrap--1");
const CircleWrap2 = document.querySelector(".circle-wrap--2");
const bgMovie = document.querySelector(".bg-movie");
const fixedNav = document.querySelector(".fixed-nav");
const sideEntry = document.querySelector(".side-entry");

const initOpeningAnim = () => {
  const updateKvCircleTranslate = () => {
    const windowWidth = window.innerWidth;
    let xPercent, yPercent;

    if (windowWidth < 959) {
      xPercent = -65;
      yPercent = -75;
    } else {
      xPercent = -75;
      yPercent = -70;
    }

    return { xPercent, yPercent };
  };

  openingTl
    .to(
      coverWrap,
      {
        clipPath: " circle(25% at 50% 50%)",
        ease: "expo.out",
      },
      "+=1"
    )
    .to(
      coverLogo,
      {
        scale: 1,
      },
      "<"
    )
    .to(
      coverWrap,
      {
        clipPath: " circle(30% at 50% 50%)",
        duration: 0.1,
      },
      "+=0.3"
    )
    .to(coverWrap, {
      clipPath: " circle(25% at 50% 50%)",
    })
    .to(
      coverWrap,
      {
        clipPath: " circle(10% at 50% 50%)",
      },
      "+=0.3"
    )
    .to(
      kv,
      {
        clipPath: " circle(5% at 50% 50%)",
      },
      "<"
    )
    .to(
      coverLogo,
      {
        scale: 0,
        alpha: 0,
      },
      "<"
    )
    .to(
      coverWrap,
      {
        clipPath: " circle(100% at 50% 50%)",
        alpha: 0,
        duration: 1,
      },
      "+=0.3"
    )
    .to(
      kv,
      {
        clipPath: " circle(100% at 50% 50%)",
        duration: 1,
      },
      "<"
    )
    .to(
      bgMovie,
      {
        clipPath: " circle(100% at 50% 50%)",
        duration: 1,
      },
      "<"
    )
    .to(
      kvCircleWrap,
      {
        scale: 1,
        duration: 1,
        delay: 0.1,
        ease: "expo.out",
      },
      "<"
    )
    .add(() => {
      CircleWrap1.classList.add("is-active");
    }, "<")
    .add(() => {
      CircleWrap2.classList.add("is-active");
    }, "<")
    .to(coverWrap, { display: "none" }, "<")
    .to(document.body, { backgroundColor: "#ffd700" }, "<")
    .add(() => {
      fixedNav.classList.add("is-visible");
    }, "<")
    .add(() => {
      sideEntry.classList.add("is-view");
    }, "+=0.5")
    .add(() => {
      scrollLock.deactivate();
    });
};

const kvMove = () => {
  modGsap.ScrollTrigger.create({
    start: "top top-=10",
    onEnter: () => {
      kvCircle.classList.add("is-move");
    },
  });
};

const forceScrollTop = () => {
  window.history.scrollRestoration = "manual";
};
const leadMove = () => {
  let initialScrollPosition = null;
  let triggerFired = false;
  let userHasScrolled = false;

  const checkScroll = () => {
    if (triggerFired) return;

    const currentScrollPosition = window.scrollY;

    if (initialScrollPosition === null) {
      initialScrollPosition = currentScrollPosition;
      return;
    }

    const scrollDistance = Math.abs(
      currentScrollPosition - initialScrollPosition
    );

    // console.log("Scroll check:", {
    //   userHasScrolled,
    //   scrollDistance,
    //   initialScrollPosition,
    //   currentScrollPosition,
    // });

    if (userHasScrolled && scrollDistance >= 50) {
      const targetElement = document.querySelector(".index-lead__inner");
      if (targetElement) {
        targetElement.classList.add("is-visible");
        // console.log("Added is-visible class");
      } else {
        // console.error("Target element not found");
      }
      triggerFired = true;
      window.removeEventListener("scroll", onScroll);
    }
  };

  const onScroll = () => {
    if (!userHasScrolled) {
      userHasScrolled = true;
      initialScrollPosition = window.scrollY;
      // console.log("User started scrolling");
    }
    checkScroll();
  };

  const init = () => {
    // リセット完了後の処理
    initialScrollPosition = window.scrollY;
    // console.log("Initial scroll position:", initialScrollPosition);

    window.addEventListener("scroll", onScroll, { passive: true });

    // 最上部にいることを確認
    if (initialScrollPosition === 0) {
      userHasScrolled = false;
      // console.log("Page loaded at top, waiting for user scroll");
    } else {
      // console.warn(
      //   "Unexpected initial scroll position:",
      //   initialScrollPosition
      // );
    }
  };

  init();
};
const counters = () => {
  modGsap.ScrollTrigger.config({
    autoRefreshEvents: "visibilitychange,DOMContentLoaded,load",
    scrollThreshold: 50,
  });

  const counters = {
    employees: document.getElementById("employees"),
    clients: document.getElementById("clients"),
    workers: document.getElementById("workers"),
  };

  let currentValues = {
    employees: 0,
    clients: 0,
    workers: 0,
  };

  function animateCounter(counter, startValue, endValue, duration) {
    // if (!counter) {
    //   console.error("Counter element is null or undefined");
    //   return;
    // }
    modGsap.gsap.to(counter, {
      innerHTML: endValue,
      duration: duration,
      ease: "power1.inOut",
      snap: { innerHTML: 1 },
      modifiers: {
        innerHTML: (value) =>
          new Intl.NumberFormat("ja-JP").format(Math.round(value)),
      },
    });
  }

  function updateCounters(section, direction) {
    // if (!section) {
    //   console.error("Section is null or undefined");
    //   return;
    // }

    for (const [key, counter] of Object.entries(counters)) {
      // if (!section.dataset[key]) {
      //   console.error(`Data attribute ${key} is missing for section`);
      //   continue;
      // }

      const newValue = parseInt(section.dataset[key], 10);
      const startValue = currentValues[key];

      // console.log(
      //   `Updating ${key}: ${startValue} -> ${newValue} (${direction})`
      // );

      if (startValue !== newValue) {
        animateCounter(counter, startValue, newValue, 1);
        currentValues[key] = newValue;
      }
    }
  }

  const sections = document.querySelectorAll(".phase-text-block");
  let lastActiveIndex = 0;

  sections.forEach((section, index) => {
    modGsap.ScrollTrigger.create({
      trigger: section,
      start: "top center",
      end: index === sections.length - 1 ? "bottom bottom" : "bottom center",
      onEnter: () => {
        // console.log("Enter forward", section);
        updateCounters(section, "forward");
        lastActiveIndex = index;
      },
      onEnterBack: () => {
        // console.log("Enter back", section);
        updateCounters(section, "backward");
        lastActiveIndex = index;
      },
      onLeave: () => {
        if (index === sections.length - 1) {
          // console.log("Leave last section");
          updateCounters(section, "forward");
        }
      },
      onLeaveBack: () => {
        if (index === 0) {
          // console.log("Leave back first section");
          updateCounters(section, "backward");
        }
      },
      // markers: true, // デバッグ用。問題が解決したら削除してください。
    });
  });

  // 初期値を設定
  const firstSection = sections[0];
  if (firstSection) {
    updateCounters(firstSection, "initial");
  } else {
    console.error("No first section found");
  }

  // スクロールイベントリスナーを追加
  window.addEventListener("scroll", () => {
    const scrollPosition = window.scrollY + window.innerHeight / 2;
    let activeIndex = -1;

    sections.forEach((section, index) => {
      const rect = section.getBoundingClientRect();
      const sectionTop = rect.top + window.scrollY;
      const sectionBottom = sectionTop + rect.height;

      if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
        activeIndex = index;
      }
    });
    if (activeIndex !== -1 && activeIndex !== lastActiveIndex) {
      updateCounters(
        sections[activeIndex],
        activeIndex > lastActiveIndex ? "forward" : "backward"
      );
      lastActiveIndex = activeIndex;
    }
  });
};
const navAnchor = () => {
  const sections = modGsap.gsap.utils.toArray(".target-section");
  const navItems = modGsap.gsap.utils.toArray(".fixed-nav-item");

  // 最初のセクションの上端位置を取得
  const firstSectionTop =
    sections[0].getBoundingClientRect().top + window.pageYOffset;

  sections.forEach((section, index) => {
    modGsap.ScrollTrigger.create({
      trigger: section,
      start: "top center",
      end: "bottom center",
      onEnter: () => setActiveNav(index),
      onEnterBack: () => setActiveNav(index),
      onLeave: () => checkScrollPosition(),
      onLeaveBack: () => checkScrollPosition(),
    });
  });

  function setActiveNav(index) {
    navItems.forEach((item, i) => {
      if (i === index) {
        item.classList.add(IS_ACTIVE);
      } else {
        item.classList.remove(IS_ACTIVE);
      }
    });
  }

  function checkScrollPosition() {
    const scrollPosition = window.pageYOffset;
    if (scrollPosition < firstSectionTop) {
      navItems.forEach((item) => item.classList.remove(IS_ACTIVE));
    }
  }

  // 初期化時にスクロール位置をチェック
  checkScrollPosition();
};
const phaseAnchor = () => {
  const phaseSections = modGsap.gsap.utils.toArray(".phase-text-block");
  const phaseFigure = modGsap.gsap.utils.toArray(".phase-figure-content");

  phaseSections.forEach((section, index) => {
    modGsap.ScrollTrigger.create({
      trigger: section,
      start: "top center",
      end: "bottom center",
      onEnter: () => setActiveNav(index),
      onEnterBack: () => setActiveNav(index),
    });
  });

  function setActiveNav(index) {
    phaseFigure.forEach((item, i) => {
      if (i === index) {
        item.classList.add("done");
        item.classList.add("is-active");
      } else {
        item.classList.remove("is-active");
      }
    });
  }
};
const followCircle = () => {
  modGsap.gsap.to(".index-distance-circle", {
    ScrollTrigger: {
      pin: true,
      trigger: ".index-distance-circle",
      startTrigger: ".index-distance-body",
      start: "top 10%",
      endTrigger: `.index-realization`,
      end: "top+=50px 60%",
    },
  });
};
const youtubePlayerInit = () => {
  let player;

  // Load YouTube IFrame API
  var tag = document.createElement("script");
  tag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName("script")[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  // YouTube IFrame API Ready
  window.onYouTubeIframeAPIReady = function () {
    createPlayer();
  };

  function createPlayer() {
    const videoId = "0JzkjwqK4Vg";
    player = new YT.Player("youtube-player", {
      height: "360",
      width: "640",
      videoId: videoId,
      playerVars: {
        autoplay: 0,
        controls: 1,
        rel: 0,
        showinfo: 0,
        loop: 1,
        playlist: videoId,
        mute: 1,
      },
      events: {
        onReady: onPlayerReady,
        onStateChange: onPlayerStateChange,
      },
    });
  }

  function onPlayerReady(event) {
    const iframe = player.getIframe();
    iframe.setAttribute(
      "allow",
      "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    );
    iframe.setAttribute("frameborder", "0");
    iframe.setAttribute("allowfullscreen", "");
    iframe.setAttribute("referrerpolicy", "strict-origin-when-cross-origin");
    iframe.setAttribute("title", "タイミーTVCM「店長」篇（30秒）※字幕あり");

    modGsap.ScrollTrigger.create({
      trigger: ".video-container",
      start: "top 80%",
      // end: "bottom 20%",
      // markers: true,
      onEnter: () => {
        if (player && typeof player.playVideo === "function") {
          player.mute();
          setTimeout(() => {
            player.playVideo();
          }, 1000);
        }
      },
      onLeave: () => {
        if (player && typeof player.pauseVideo === "function") {
          player.pauseVideo();
        }
      },
      onEnterBack: () => {
        if (player && typeof player.playVideo === "function") {
          player.mute();
          setTimeout(() => {
            player.playVideo();
          }, 1000);
        }
      },
      onLeaveBack: () => {
        if (player && typeof player.pauseVideo === "function") {
          player.pauseVideo();
        }
      },
    });
  }

  function onPlayerStateChange(event) {
    // ここに必要な処理があれば追加
  }
};
const youtubeCover = () => {
  const videoCover = document.querySelector(".video-container__cover");
  modGsap.ScrollTrigger.create({
    trigger: ".video-container__cover",
    start: "top 80%",
    // end: "bottom 20%",
    // markers: true,
    onEnter: () => {
      videoCover.classList.add("is-view");
    },
  });
};
const smpCounter = () => {
  const countUpTriggers = document.querySelectorAll(
    ".phase-content-figure-inner .phase-counter"
  );
  const countUpTargets = document.querySelectorAll(
    ".phase-content-figure-inner .counter-num"
  );
  countUpTargets.forEach((countUpTarget, index) => {
    const elementDic = {
      from: parseInt(countUpTarget.dataset.from),
      to: parseInt(countUpTarget.dataset.to),
    };
    const elementNum = { count: elementDic.from };

    modGsap.gsap.to(elementNum, {
      count: elementDic.to,
      duration: 1,
      ease: "none",
      scrollTrigger: {
        trigger: countUpTriggers[index],
        start: "top 90%",
        // markers: true,
      },
      onUpdate: () => {
        countUpTarget.textContent = Math.floor(elementNum.count).toLocaleString(
          "ja-JP"
        );
      },
    });
  });
};
const kvCircleState = () => {
  const kvCircleWrapItem = document.querySelectorAll(".circle-wrap");
  const dataSection = document.querySelector(".index-data");
  // console.log(kvCircleWrapItem);
  kvCircleWrapItem.forEach((item) => {
    modGsap.ScrollTrigger.create({
      trigger: dataSection,
      start: "top center",
      onEnter: () => {
        item.classList.add("is-pause");
      },
      onLeaveBack: () => {
        item.classList.remove("is-pause");
      },
    });
  });
};
const bgVideoState = () => {
  const video = document.querySelector(".js-video");
  const stopSection = document.querySelector(".index-distance");
  modGsap.ScrollTrigger.create({
    trigger: stopSection,
    start: "center top",
    end: "bottom center",
    onEnter: () => video.pause(),
    onLeaveBack: () => video.play(),
  });
};

const videoModeSwitch = () => {
  let is_playing = false;
  const video = document.querySelector(".js-video");
  const imageElement = document.querySelector(".js-video-static");

  video
    .play()
    .then(() => {
      // 省電力モードではないときの処理
      // console.log("省電力モードではありません");
    })
    .catch((error) => {
      // 省電力モードのときの処理
      video.style.display = "none";
      if (imageElement) {
        imageElement.style.display = "block";
      }
    });
};
// ===========================================
//  init / 初期化
// ===========================================
const init = () => {
  new CssCustomProperties();

  modGsap.onceAnimation();
  setupDrawer();
  initOpeningAnim();
  kvMove();
  bgVideoState();
  kvCircleState();
  leadMove();
  navAnchor();
  phaseAnchor();
  counters();
  youtubePlayerInit();
  youtubeCover();
  smpCounter();
  // SmoothScroll を最後に初期化
  new SmoothScroll();
  videoModeSwitch();
};

// ===========================================
//  DOMContentLoaded / 読み込み
// ===========================================

window.addEventListener("DOMContentLoaded", () => {
  forceScrollTop();
});

// ===========================================
//  load / 読み込み
// ===========================================

window.addEventListener("load", () => {
  init();
});
